/* =====================================================
   Control Buttons Component – Version 2.1 (Modified: July 31, 2025)
   Reset, undo, and submit action buttons
   Date Modified: 31 July 2025 | Time: Current
===================================================== */

import { memo, useCallback } from 'react'
import { useGameState } from '../hooks/useGameState'
import styles from './ControlButtons.module.css'

/**
 * Control buttons for game actions
 */
function ControlButtons() {
  const { resetGame, undoLastPlacement, submitEquation, currentIndex } = useGameState()

  const handleReset = useCallback(() => {
    resetGame()
  }, [resetGame])

  const handleUndo = useCallback(() => {
    undoLastPlacement()
  }, [undoLastPlacement])

  const handleSubmit = useCallback(() => {
    submitEquation()
  }, [submitEquation])

  return (
    <div className={styles.buttonRow}>
      <ActionButton
        onClick={handleReset}
        className={styles.resetButton}
        title="Reset entire game to initial state"
      >
        🔄 Reset
      </ActionButton>

      <ActionButton
        onClick={handleUndo}
        disabled={currentIndex === 0}
        className={styles.undoButton}
        title="Undo last number/operator placement"
      >
        ↩️ Undo
      </ActionButton>

      <ActionButton
        onClick={handleSubmit}
        className={styles.submitButton}
        title="Submit current equation for validation"
      >
        ✅ Submit
      </ActionButton>
    </div>
  )
}

/**
 * Individual action button component
 * Memoized to prevent unnecessary re-renders
 */
const ActionButton = memo(function ActionButton({ 
  onClick, 
  disabled = false, 
  className = '', 
  title = '', 
  children 
}) {
  return (
    <button
      className={`${styles.controlButton} ${className}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  )
})

export default ControlButtons